import { render } from "./DonationsReportPage.vue?vue&type=template&id=c7bcb4a4&scoped=true"
import script from "./DonationsReportPage.vue?vue&type=script&lang=js"
export * from "./DonationsReportPage.vue?vue&type=script&lang=js"

import "./DonationsReportPage.vue?vue&type=style&index=0&id=c7bcb4a4&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/fep.theismailiusa.org/srv/fep.theismailiusa.org/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7bcb4a4"]])

export default __exports__